import { useContext, useRef } from 'react';
import { useCompareMode, useComparingConversationsParams } from 'src/hooks';
import ThreadInputBoxContext from 'src/contexts/ThreadInputBoxContext';
import { FadeTransition } from 'src/animations/FadeTransition';
import styles from './CompareModeSameModelsError.module.scss';

export const CompareModeSameModelsError = () => {
  const nodeRef = useRef<HTMLDivElement>(null);

  const { threadInputBoxValue } = useContext(ThreadInputBoxContext);
  const { firstCompareModel, secondCompareModel } = useCompareMode();
  const { isCompareMode } = useComparingConversationsParams();
  const isSameModel = firstCompareModel === secondCompareModel;

  const isErrorMessageVisible = !!(
    isCompareMode &&
    isSameModel &&
    threadInputBoxValue
  );

  return (
    <FadeTransition inProp={isErrorMessageVisible} nodeRef={nodeRef}>
      <div className={styles.root} ref={nodeRef}>
        <div className={styles.errorBlock}>
          <span>
            Please select two different AI models to continue. You've currently
            selected the same model.
          </span>
        </div>
      </div>
    </FadeTransition>
  );
};
